import request from '@/core/request'
import { useToast } from '@/ui-runtime/core/composable/use-toast'
import { useRoute } from 'vue-router'
import { useDialogs } from '@/ui-runtime/core/composable/use-dialogs'
import { useQueryClient } from '@tanstack/vue-query'
import { ref } from 'vue'

export const defaultConfig = {
  key: 'ui-lottery1', // 每个ui组件必须有
  type: 'ui-lottery1', //
  images: {
    // 支持多个tab的背景图
    lotteryBg: ['lottery-bg1', 'lottery-bg2'],
    lotteryGlassBg: 'lottery-glass-bg',
    lotteryBall1: 'lottery-ball1',
    lotteryBall2: 'lottery-ball2',
    lotteryBall3: 'lottery-ball3',
    lotteryBall4: 'lottery-ball4',
    lotteryBall5: 'lottery-ball5',
    lotteryBall6: 'lottery-ball6',
    lotteryBall7: 'lottery-ball7',
    lotteryBall8: 'lottery-ball8',
  }, // 每个组件的配置都统一放到images中管理
  layout: {
    // 布局相关的配置统一放到layout中
    wrapper: {
      //   抽奖蒙版的配置
      lotteryMaskWrapper: {
        pt: '491',
      },
    }, // 单个ui组件wrapper的ui配置 q-section相关的东西都能进行配置
    ballsConfig: [
      { 'bg-i': 'lottery-ball1', pl: '3', pt: '73' },
      { 'bg-i': 'lottery-ball2', pl: '40', pt: '84' },
      { 'bg-i': 'lottery-ball3', pl: '76', pt: '83' },
      { 'bg-i': 'lottery-ball4', pl: '114', pt: '79' },
      { 'bg-i': 'lottery-ball5', pl: '10', pt: '92' },
      { 'bg-i': 'lottery-ball6', pl: '34', pt: '113' },
      { 'bg-i': 'lottery-ball7', pl: '66', pt: '118' },
      { 'bg-i': 'lottery-ball8', pl: '97', pt: '105' },
    ],
  },
  config: {
    // 抽奖接口
    doLotteryApi: '/api/activities/general/lottery_pool/start',
    // 获取抽奖奖励配置接口
    getLotteryConfigApi: '/api/activities/general/lottery_pool/list',
    // 就算是一个奖池，也配置成数组，方便兼容多个奖池
    componentIds: [2, 3],
    lotteryNum: [1, 10],
    animationMs: 3000,
    rewardsDialogName: 'rewards',
  }, //每个ui组件的一些配置字段相关的东西
}

export const useLottery = (uiMeta: any, active: number, type: number, options?: { onSuccess?: () => void }) => {
  const { $toast } = useToast()
  const route = useRoute()
  const activity_code = route.meta?.activity_code
  const componentIds = uiMeta.config?.componentIds
  const { $dialogs } = useDialogs()
  const queryClient = useQueryClient()
  const isLotterying = ref(false)

  const handleDoLottery = async (animationCallBack: Function) => {
    if (isLotterying.value) {
      $toast.show('抽奖中，请稍后再试')
      return
    }
    try {
      const res = await request.post(uiMeta.config.doLotteryApi, {
        activity_code,
        component_id: componentIds[active],
        lottery_num: uiMeta?.config?.lotteryNum[type],
      })

      if (res.status !== 0) {
        $toast.show((res as any)?.msg)
        return
      }
      isLotterying.value = true
      await animationCallBack(uiMeta?.config?.animationMs)
      $dialogs[uiMeta?.config?.rewardsDialogName].open(res.data?.rewards)

      // 抽奖成功后，使 showcaseList 查询失效，触发重新获取数据
      queryClient.invalidateQueries({ queryKey: ['showcaseList'] })
      isLotterying.value = false

      // 如果提供了 onSuccess 回调，也调用它
      if (options?.onSuccess) {
        options.onSuccess()
      }
    } catch (error) {
      $toast.show(error as any)
    }
  }

  return {
    handleDoLottery,
  }
}
